import { baseService } from "../base";

export type TNetworkRoute = {
  id: string;
  organizationId: string;
  organization?: { id: string; name: string; slug: string };
  vesselId?: string;
  origin: string;
  destination: string;
  departureDate: string;
  returnDate?: string;
  maxVolume: number;
  costPerCube?: number;
  minimumCost?: number;
  status: string;
  isPublic: boolean;
  bookings?: TNetworkBooking[];
  createdAt: string;
};

export type TNetworkBooking = {
  id: string;
  networkRouteId: string;
  requestingOrgId: string;
  requestingOrg?: { id: string; name: string; slug: string };
  cubesRequested: number;
  status: string;
  notes?: string;
  createdAt: string;
};

export type TJobReferral = {
  id: string;
  sourceOrgId: string;
  sourceOrg?: { id: string; name: string; slug: string };
  targetOrgId?: string;
  targetOrg?: { id: string; name: string; slug: string };
  description: string;
  status: string;
  referralFee?: number;
  claimedByOrgId?: string;
  claimedByOrg?: { id: string; name: string; slug: string };
  createdAt: string;
};

export const networkService = {
  // Routes
  getOpenRoutes: async () => {
    const { data } = await baseService.get<TNetworkRoute[]>("/network/routes");
    return data;
  },
  getMyRoutes: async () => {
    const { data } = await baseService.get<TNetworkRoute[]>("/network/routes/mine");
    return data;
  },
  createRoute: async (body: {
    origin: string;
    destination: string;
    departureDate: string;
    returnDate?: string;
    maxVolume: number;
    costPerCube?: number;
    minimumCost?: number;
    vesselId?: string;
  }) => {
    const { data } = await baseService.post<TNetworkRoute>("/network/routes", body);
    return data;
  },
  bookRoute: async (routeId: string, body: { cubesRequested: number; notes?: string }) => {
    const { data } = await baseService.post<TNetworkBooking>(`/network/routes/${routeId}/book`, body);
    return data;
  },
  updateBooking: async (routeId: string, bookingId: string, body: { status: string }) => {
    const { data } = await baseService.patch(`/network/routes/${routeId}/bookings/${bookingId}`, body);
    return data;
  },

  // Referrals
  getOpenReferrals: async () => {
    const { data } = await baseService.get<TJobReferral[]>("/network/referrals");
    return data;
  },
  getMyReferrals: async () => {
    const { data } = await baseService.get<TJobReferral[]>("/network/referrals/mine");
    return data;
  },
  createReferral: async (body: { description: string; targetOrgId?: string; referralFee?: number }) => {
    const { data } = await baseService.post<TJobReferral>("/network/referrals", body);
    return data;
  },
  claimReferral: async (id: string) => {
    const { data } = await baseService.post<TJobReferral>(`/network/referrals/${id}/claim`);
    return data;
  },
  updateReferral: async (id: string, body: { status: string }) => {
    const { data } = await baseService.patch<TJobReferral>(`/network/referrals/${id}`, body);
    return data;
  },
};
